import { SalonIndex } from '@drycut/booking-components';
import { FullscreenImageLayout } from '@drycut/ui-components';
import { useDocumentTitle } from 'usehooks-ts';

export function Salons(): React.ReactElement {
  useDocumentTitle('DRYCUT - Salons');

  return (
    <FullscreenImageLayout src="/images/booking-bg.jpg">
      <SalonIndex />
    </FullscreenImageLayout>
  );
}
